<div
    class="home-page"
    [appTrack]="'homepage_viewed'"
    [appTrackOnInit]="true"
    [appTrackParams]="{
        user_role: isManagingCommunity ? 'community_manager' : 'member'
    }"
>
    <div class="greeting">
        <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center">
            <div>
                <h1>👋{{ 'home.greeting.title' | translate }} {{ currentUser.firstName }},</h1>
                <p>{{ 'home.greeting.subTitle' | translate }}</p>
            </div>

            <div *ngIf="isManagingCommunity && !isAlreadyInWudoClub">
                <div class="banner-encourage-join-wudoClub rounded" (click)="redirectToJoinWudoClubPage()">
                    <span>
                        {{ 'home.pages.home.bannerTitle' | translate }}
                    </span>

                    <div class="banner-click font-weight-bold">{{ 'home.pages.home.bannerClick' | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="home-grid">
        <!-- 0% - 75% -> display to everyone | 75% - 100% -> display only top part (class.short-progress) and only to non community manager -->
        <app-widget-progress
            [welcomePercentage]="welcomePercentage"
            *ngIf="welcomePercentage < 75 || !isManagingCommunity"
            [class.short-progress]="welcomePercentage >= 75"
        ></app-widget-progress>

        <!-- shows to community manager over 75% -->
        <app-widget-invite *ngIf="welcomePercentage >= 75 && isManagingCommunity"></app-widget-invite>

        <!-- shows to everyone over 75% -->
        <app-widget-connect *ngIf="welcomePercentage >= 75"></app-widget-connect>

        <div class="widgets-info">
            <app-widget-info [behavior]="'notification'"></app-widget-info>
            <!-- <app-widget-info [value]="0" [behavior]="'news'"></app-widget-info> -->
            <app-widget-info
                [value]="registrationCount"
                (openRegistrationSidebar)="isRegistrationSidebarVisible = true"
                [behavior]="'registration'"
                class="d-md-block d-none"
            ></app-widget-info>
        </div>

        <app-widget-publication></app-widget-publication>

        <!-- registrations mobile -->
        <app-widget-info
            [value]="registrationCount"
            (openRegistrationSidebar)="isRegistrationSidebarVisible = true"
            [behavior]="'registration'"
            class="d-md-none"
        ></app-widget-info>

        <app-widget-project></app-widget-project>
        <app-widget-event></app-widget-event>
    </div>
</div>

<app-widget-registration-list
    [(visible)]="isRegistrationSidebarVisible"
    (registrationsChanged)="onRegistrationsChanged($event)"
></app-widget-registration-list>
